/**
 * Lexody design tokens — JS export for mobile (React Native) and web (React).
 * Source of truth: ./tokens.json
 */
const tokens = require('./tokens.json');
const iconMap = require('./icon-map');

const { primitives, semantic, meta, foundations: rawFoundations } = tokens;

const DEFAULT_RADIUS = {
  xs: 4,
  s: 6,
  m: 8,
  l: 12,
  xl: 16,
  full: 999,
  sm: 8,
  md: 12,
  lg: 16,
};

const foundations = {
  ...rawFoundations,
  radius: rawFoundations.radius || DEFAULT_RADIUS,
};

const radius = foundations.radius;
const spacing = foundations.spacing;
const border = foundations.border;

/** Convert hex color to rgba string */
function hexToRgba(hex, alpha) {
  const normalized = hex.replace('#', '');
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Legacy-friendly flat aliases matching old colors.js names where possible */
const legacy = {
  lightBlue: primitives.blue['500'],
  darkBlue: primitives.blue['700'],
  mediumBlue: primitives.blue['600'],
  green: primitives.green['500'],
  yellow: primitives.yellow['500'],
  red: primitives.orange['500'],
  premiumPink: primitives.pink['500'],
  premiumPurple: primitives.violet['500'],
  darkPurple: primitives.violet['700'],
  grey: primitives.grey['600'],
  white: '#FFFFFF',
  black: '#000000',
};

/** Typography role styles for mobile (React Native) */
function typographyRole(role, platform = 'mobile') {
  const spec = foundations.typography.roles[role];
  if (!spec) return {};
  const size = spec[platform] || spec.mobile;
  return {
    fontFamily: spec.fontFamily,
    fontSize: size.fontSize,
    lineHeight: size.lineHeight,
    color: spec.color,
  };
}

/** Shadow preset for React Native (iOS + Android) */
function shadowPreset(name, platform = 'ios') {
  const preset = foundations.shadow[name];
  if (!preset) return {};
  if (platform === 'android') return preset.android;
  return preset.ios;
}

module.exports = {
  default: tokens,
  primitives,
  semantic,
  semanticColors: semantic,
  meta,
  legacy,
  foundations,
  radius,
  spacing,
  border,
  hexToRgba,
  typographyRole,
  shadowPreset,
  ...iconMap,
};
